Bingo.Asset = {};

Bingo.Asset.init = function (currentStep) {
    if (currentStep) {
        $('body').addClass('section-editing-active');
    }
    $('body').on('click', '.section-heading a.close', function () {
        if ($(this).parents('.multistep-section').find('input[name=cancel]').length) {
            $(this).parents('.multistep-section').find('[name=cancel]').click();
        } else {
            $('#modal-cancel').modal('show');
        }
    });
    if (!$('[name=cancel]').length) {
        let wasActive = false;
        $('.multistep-section').each(function () {
            if ($(this).hasClass('section-editing-active')) {
                wasActive = true;
            }
            if (wasActive) {
                $(this).find('.multistep-switch').hide();
            }
        });
    }
    $('.multistep-section input, .multistep-section select, .multistep-section textarea').on('change input', () => {
        $('.multistep-switch').hide();
    });
    $('body').on('click', '.multistep-section .btn, .multistep-section a:not(.multistep-switch):not(.gallery-control):not(.cover):not([data-fancybox]):not([data-toggle="tab"]):not([target="_blank"]), .multistep-section .cke_button_icon', () => {
        $('.multistep-switch').hide();
    });
};
